import { USER_TYPE } from "utils/static-data";

export const isMasterAdmin = (login) =>
    !!login?.company?.master && login?.user?.userType === USER_TYPE.ADMIN;
